export default "__VITE_ASSET__CXiNPVG2__"